declare var SimpleBar;

namespace AgerLMS.WebSite {

    export interface CoursePageWidgetRequest {
        ItemId: number;
        ItemType: string;
    }

    @Serenity.Decorators.registerClass()
    export class CoursePageWidget extends Serenity.Widget<CoursePageWidgetRequest> {

        constructor(element: JQuery, opt: CoursePageWidgetRequest) {
            super(element, opt);

            let q = this.getQueryString();
            if (q["tabs"] != void 0) window.setTimeout(()=>  $("a#" + q["tabs"] + "-tab").click(), 100);

            $("#SelectProductToCart .boxed-check").eq(0).click();
            
            var self = this;
            var addToCart = $("#CourseAddtoCartBtn");
            addToCart.click(function(e) {
                e.preventDefault();
                var priceId = $("#SelectProductToCart .boxed-check input:checked").attr("data-itemid");
                LMS.PublicOrderService.AddToCart({
                    ItemId : self.options.ItemId,
                    ItemType : self.options.ItemType,
                    PriceItemId : priceId,
                    Quantity : 1
                }, response => {
                    var text = "Eğitim sepetinize eklendi.";
                    if ( self.options.ItemType == "webinar" ) {
                        text = "(" + response.UsagePeriod + " gün " + response.WatchCount + " izleme) " + response.ItemName + " sepetinize eklendi.";
                    } 
                    let goUrl = (url: string)=> {
                        addToCart.removeClass("loadingbar primary");
                        window.setTimeout(() => {
                            window.location.href = url;
                        }, 100);
                    }
                    SweetAlert.swal_success_then2(text, () => {
                        goUrl(Q.resolveUrl("~/alisveris-sepeti"));
                    }, () => {
                        goUrl(Q.resolveUrl("~/"));
                    });
                }, {
                    onError: r => {
                        SweetAlert.swal_alert("Hata", r.Error.Message);
                        addToCart.removeClass("loadingbar primary");
                        addToCart.prop("disabled", false);
                    }
                });
            });
            
            //Bedavaya Kursa Kayıt için
            var registerforthisCourse = $("#RegisterforthisCourse");
            registerforthisCourse.click(function(e) {
                e.preventDefault();

                LMS.CourseService.CourseFreePayment({ 
                    EntityId: self.options.ItemId
                }, response => {
                    addToCart.removeClass("loadingbar primary");
                    SweetAlert.swal_success_then("Kayıt Başarılı", "Kursa kayıt işleminiz başarıyla gerçekleşti.", () => {
                        window.setTimeout(() => {
                            window.location.href = Q.resolveUrl("~/odeme-basarili");
                        }, 100);
                    });
                }, {
                    onError: r => {
                        SweetAlert.swal_alert("Hata", r.Error.Message);
                        registerforthisCourse.removeClass("loadingbar primary");
                        registerforthisCourse.prop("disabled", false);
                    }
                });

                //SweetAlert.swal_info("Bilgi", "Bu kursa kayıt şuan için aktif değil.");
            });
        }

        private getQueryString() {
            return decodeURI(window.location.search).replace('?', '').split('&').map(param => param.split('=')).reduce((values, [ key, value ]) => {
                values[ key ] = value
                return values
              }, {});
        }
    }
}